import React from 'react';
import { GFQuizItem } from '../../../models/models';

type Props = {
  preTest?: GFQuizItem,
  startQuiz: (gfQuiz: GFQuizItem) => void,
}

const Locked: React.FunctionComponent<Props> = ({ preTest, startQuiz }) => (
  <div className="locked" onClick={() => { preTest && startQuiz(preTest) }}>
    <div>
      <h1>
        <span>Let’s start learning!</span>
      </h1>
    </div>
    {preTest && <div style={{ marginBottom: '10px' }}>
      <img width={64} height={64} src={preTest.imagePath} alt="gfImage" />
    </div>}
    <div>
      First, click here<br/>and complete the Pre-Test.
    </div>
    <div style={{ marginTop: '20px', fontSize: '1em'}}>
      You must complete the pre-test<br/>before accessing any instructional or assessment content.
    </div>
  </div>
);

export default Locked;
